<div class="container">
    <h1 class="mt120">Operations Manual</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>The 0perations Manual will provide you with key information needed to prepare for, launch and operate iTIM in
            your church.</p>

        <div class="row mt-5">
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="mx-auto d-table">
                    <figure class="book">
                        <img src="../../../assets/images/i-tim-manual-202x300.jpg" class="img-fluid" width="185"
                            height="279" />
                        <figcaption>Student’s Course</figcaption>
                    </figure>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="btnCenter">
                    <!-- <h2 class="text-center">Student’s Course</h2> -->
                    <a href="http://thebp.net/145085" class="btn btnSecondary mt-2">Buy Hardcopy</a>
                    <a href="../../../assets/Pdf/i-tim-manual.pdf" class="btn btnSecondary mt-2">Sample PDF</a>
                </div>
            </div>
        </div>

        <h2>Chapter 3 (Excerpts)</h2>
        <h4>What in the World is <em>Your</em> Church Doing?</h4>
        <p>After twenty-two years in the Philippines, my family and I returned to the States—where we experienced some
            &#8220;reverse culture shock.&#8221; While visiting one of our supporting churches, I walked into an adult
            Sunday School class. I saw some of the same people I had met five years earlier—some of them, it seemed,
            sitting in the same seats! I ventured to ask one member, &#8220;How long have you been in this class?&#8221;
            &#8220;Fourteen years&#8221; was the reply. &#8220;Really! How does it feel being in the same class for so
            many years?&#8221; I asked. Cupping his hand, he turned and said softly, &#8220;Well, to tell you the truth,
            after a while, it gets kind of <em>boring</em>—you know, after a while the same subjects come up again and
            again.&#8221;</p>



        <p>Think about it! This person has learned a lot about the Bible. Yet after 14 years, he is still sitting there,
            soaking it in, and maybe even souring a bit! He’s not involved, not ministering.</p>



        <p>Is that how we fulfill the Great Commission? And is this person merely an isolated case? Or does he possibly
            represent a majority of adult learners in our churches today?</p>



        <p>Robert Coleman says: <em>&#8220;It is no secret that the organized church today is in trouble. Not only has
                the institution lost momentum, but by and large, it has lost direction&#8221;</em> (Foreword to Bill
            Hull’s <em>The Disciple Making Pastor</em>, pg. 9).</p>



        <p>Momentum is directly related to direction. We have lost momentum as Christ’s ambassadors, precisely because
            we have lost direction in regard to the nature of the Great Commission. The fact is, in most churches today,
            leadership has lost sight of the discipling task to which Christ called all of us and which is the key to
            growth.</p>



        <p>Why is it that—</p>



        <ul>
            <li>Most churches are not growing? Leith Anderson in <em>Dying For Change</em> (pg. 10) says, &#8220;85% of
                America’s Protestant churches are either stagnating or dying.&#8221; Joe Aldrich, former President of
                Multnomah University, says, &#8220;In the past 10 years hardly a single county in America has
                experienced church growth.&#8221;</li>
            <li>A large majority of Christians feel that churches give undue emphasis to organizational matters, but not
                enough to spirituality?</li>
            <li>It takes 1,000 Christians 365 days to win one person to Christ?</li>
            <li>The United States is becoming more pagan each year, and is now reported to be the fourth largest mission
                field in the world?</li>
            <li>While evangelical Christianity has been standing still, some of the cults have grown at an amazing pace?
                The Mormons for example, now have around 6,500,000 members, making them one of the largest church bodies
                in North America. And how about this statistic: they have nearly 400,000 students enrolled in their
                church seminaries worldwide.</li>
        </ul>



        <h4>Pastors Share the Problem</h4>



        <ul>
            <li>The average stay of a church pastor is between 3 and 4 years. Yet many studies suggest that a pastor’s
                most productive years only <em>begin</em> between the fourth and the seventh years.</li>
            <li>Most pastors feel overwhelmed, like they&#8217;re doing too many things.</li>
            <li>Most pastors are caught up doing the urgent things and have little time for the important things.</li>
            <li>Many pastors are not practicing a discipling ministry, even though this is the central command of our
                Lord (Matthew 28:18-20).</li>
        </ul>



        <h4>Church members Share the Problem Too</h4>



        <ul>
            <li>Lay people see the minister as just that—the person who does the ministry—all of it if possible.
                &#8220;That’s why we pay him,&#8221; they tell us.</li>
            <li>Church members have little awareness that they are to minister in the church—and that the pastor is the
                equipping leader of the team.</li>
            <li>Church members don’t seem to know that they are in a war zone, and that the enemy is all about them (1
                Peter 5:8).</li>
            <li>Church members in general have a terrible knowledge of Scripture, making them ineffective Christians in
                their homes, work places and communities; they are incapable of discipling others.</li>
            <li>According to a Gallup poll, of the nearly 100 million &#8220;evangelicals,&#8221; only 7% had any
                evangelical training and only 2% had introduced anyone to Christ!</li>
        </ul>



        <p>Yet there are churches where discipling is central, and these churches are growing in numbers and in
            spiritual depth and ministry effectiveness. But unfortunately, in the vast majority of churches, and among
            the vast majority of church members, a great spiritual malaise exists.</p>



        <h4>What Churches Should Do About It</h4>



        <p>We need to view ministry in the context of Jesus’ mandate to &#8220;<em>make disciples.&#8221;</em> This
            command in Matthew 28 still constitutes the &#8220;marching orders&#8221; for us and our churches. It is the
            key to effectively continuing Christ’s ministry—<em>&#8220;in Jerusalem&#8221;, &#8220;Judea and
                Samaria,&#8221; and &#8220;to the ends of the earth&#8221;</em> (Acts 1:8).</p>



        <p>In his forward to <em>The Disciple-Making Pastor</em>, Robert Coleman claims &#8220;we have drifted so far
            from the mandate of Christ, that persons who take it as the pattern of their lives are looked upon as
            fanatics.&#8221;</p>



        <p>In <em>Marks Of A Healthy Church</em> John MacArthur says that &#8220;the teaching pastor is to perfect the
            saints, and the saints are to do the work of the ministry so that the Body of Christ may be built up.&#8221;
            And in <em>Body Dynamics</em> he declares: &#8220;The local church essentially is a training place to equip
            Christians to carry out their own ministries.&#8221;</p>



        <p>Ray Stedman in <em>Body Life</em> affirms &#8220;The declaration of Ephesians 4 is that the ultimate work of
            the church in the world is to be done by the saints—plain, ordinary Christians—and not by a professional
            clergy or a few select laymen.&#8221; And in <em>Lifestyle Evangelism</em> Joe Aldrich declares that
            &#8220;The pastor’s major job is to help others minister—not do all the work of ministry himself.&#8221;</p>



        <p>Yet lay ministry is so ineffectively practiced in most churches as to constitute a great &#8220;sin of
            omission.&#8221; Few churches are making disciples consistently and effectively. It is this great omission
            that is responsible for much of the stagnation in many of our churches today. Still more tragic, the
            spiritual condition of our communities must in part be laid at the feet of a disobedient church.</p>



        <h4>Four Reasons Every Christian Should Minister</h4>



        <p>Scripture teaches it. <em>&#8220;It was He who gave some to be apostles, some to be prophets, some to be
                evangelists, and some to be pastors and teachers, to prepare God’s people for works of service so that
                the body of Christ may be built up&#8221;</em> (Ephesians 4:11-12). <em>&#8220;Each one should use
                whatever gift he has received to serve others, faithfully administering God’s grace in its various
                forms&#8221;</em> (1 Peter 4:10).</p>



        <p><strong>The Pastor Needs It</strong>. Many pastors are massively overworked. Pastors cannot do all of the
            things expected of them. According to a seminar conducted in a large mid-western church, the average
            expectation was for the pastor to serve an incredible 136.5 hours per week! (Powell, <em>Welcome To Your
                Ministry</em>, p. 27). Not even a &#8220;super-human&#8221; pastor can put in this many hours of course,
            but the fact is that many pastors regularly put in 70 to 80 hours per week. Pastors become overwhelmed with
            the multiple tasks, the numerous demands, and the high expectations put on them by their people. They find
            themselves running from one critical situation to another, with little or no time to put into quality
            planning for the things that are really important—like equipping God’s people for works of service.</p>



        <p><strong>God&#8217;s people need it</strong>. One reason lay people find other activities to do on
            Sundays—like puttering in the yard or watching T.V. or reading the Sunday paper, is simply because they are
            bored. They have not seen the Christian faith for what it really is, warfare! They have not effectively been
            challenged to enlist. They don’t see themselves as vital to the cause of Christ.</p>



        <p>The church today is like a professional football game: thousands of screaming fans desperately in need of
            exercise watching 22 players desperately in need of rest. Christians need to leave the comfort of their
            spectator seats and get down on the playing field. The longer the Body stays in the stands the more weak and
            useless it will become. But if it exercises its faith in service alongside the &#8220;professionals&#8221;,
            it will grow strong and healthy. The Body of Christ is built up when lay people &#8220;get into the
            game&#8221;—and become ministering members of the church.</p>



        <p><strong>The world cries out for it</strong>. People everywhere desperately need to see a loving, serving,
            teaching Christ who is touching the world through the lives of his people. This is the most pressing
            challenge confronting the Church—and it can only be addressed by the ministry of loving, concerned and
            committed Christians, with whom they are with, day after day.</p>



        <p>In his hard-hitting book, <em>The Disciple Making Pastor</em>, Bill Hull observes, &#8220;the evangelical
            church has become weak, flabby, and too dependent on artificial means that can’t simulate real spiritual
            power.&#8221; He further says: &#8220;churches are too little like training centers to shape up the saints
            and too much like cardiopulmonary wards at the local hospital.&#8221;</p>



        <p>This Manual has been written, as has been the entire curriculum of iTIM with but one goal—to help your church
            become the equipping center that God plans it to be.</p>



        <p class="has-text-align-center"><em><strong>&#8220;equip God’s people for works of service, and so build up the
                    body of Christ.</strong>&#8220;</em></p>


    </div>
    <app-static-footer></app-static-footer>
</div>